import React from 'react';
import ShopBase from './ShopBase';
import rijaBg from '../assets/rija_selection.png';

const rijaTheme = {
  background: rijaBg,

  pointsColor: 'gold',

  rewardsBg: 'rgba(200, 230, 255, 0.85)',
  rewardsBorder: '#4aa3df',
  rewardsTitle: '#2b6cb0',

  choresBg: 'rgba(255, 210, 225, 0.85)',
  choresBorder: '#e75480',
  choresTitle: '#b83260',
};

function RijaShop() {
  return <ShopBase user="rija" other="sree" theme={rijaTheme} />;
}

export default RijaShop;
